import { FC } from 'react';
import { useIntl } from 'react-intl';
import { A11yButton } from '@fe-learner-common';
import { JoinWaitlistButton } from './JoinWaitlistButton';
import { useSelfregSessionStates } from '@routes/selfreg/hooks/useSelfregSessionStates';
import { TSelfregSessionDetails } from '@api/io/selfreg.io';
import { useEnrollmentFeedback } from '@hooks/feedback/useEnrollmentFeedback';
import { useSelfregSessionEnrollment } from '@routes/selfreg/hooks/useSelfregSessionEnrollment';
import { useEnrollmentError } from '@hooks/feedback/useEnrollmentError';

const PureEnrollButton: FC<{
  sessionId: string;
}> = ({ sessionId }) => {
  const intl = useIntl();

  const {
    mutate: enroll,
    data: enrollmentData,
    isPending,
    error,
  } = useSelfregSessionEnrollment({
    sessionId,
  });

  useEnrollmentError(error);
  useEnrollmentFeedback({
    enrollmentStatus: enrollmentData?.status,
    overrideStartCourseLink:
      enrollmentData?.session.selfEnrollmentParticipationUrl || undefined,
    sessionId,
  });

  return (
    <A11yButton
      className="lf:l-btn lf:l-btn-md lf:l-btn-primary"
      isLoading={isPending}
      onClick={() => {
        enroll();
      }}
    >
      {intl.formatMessage({ id: 'catalog.course.action.enroll' })}
    </A11yButton>
  );
};

export const EnrollButton: FC<{ sessionDetails: TSelfregSessionDetails }> = ({
  sessionDetails,
}) => {
  const sessionStates = useSelfregSessionStates(sessionDetails);

  if (sessionStates.sessionFull && !sessionStates.waitlistAvailable) {
    return null;
  }

  if (sessionStates.sessionFull) {
    return <JoinWaitlistButton sessionId={sessionDetails.id} />;
  }

  return <PureEnrollButton sessionId={sessionDetails.id} />;
};
